import { call, put, take } from 'redux-saga/effects'
import api from '../api/api'
import { isResponseSuccessful } from '../helpers/utility'
import appsSchema from '../schemas/apps'
import { normalize } from 'normalizr'
import {
  FETCH_APPS_LIST_ASYNC_START,
  FETCH_APPS_LIST_ASYNC_END,
  FETCH_APPS_LIST_REQUEST,
  FETCH_APPS_LIST_SUCCESS,
  FETCH_APPS_LIST_FAIL,
} from '../actions/actions'

export function* getAppsList() {
  while (true) {
    const { queryString } = yield take(FETCH_APPS_LIST_REQUEST)
    yield put({ type: FETCH_APPS_LIST_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.getAppsList, queryString)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: FETCH_APPS_LIST_SUCCESS,
          apps: normalize(data.applications, appsSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_APPS_LIST_FAIL, error: general_errors })
      }

      yield put({ type: FETCH_APPS_LIST_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_APPS_LIST_ASYNC_END })
      yield put({ type: FETCH_APPS_LIST_FAIL, error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/appsSaga.js